<template>
  <!-- ======= About Section ======= -->
  <section id="about" class="about">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Acerca de mi</h2>
        <!--p>
          Tengo el conocimiento, la formación y las competencias específicas requeridas
          para integrarme en el desarrollo de proyectos de TI, me considero persona
          autodidacta, sagaz, proactivo, de soluciones oportunas.
        </p-->
      </div>

      <div class="row">
        <div class="col-lg-4">
          <img src="assets/img/avatar.png" class="img-fluid" width="80%" alt="">
        </div>
        <div class="col-lg-8 pt-4 pt-lg-0 content">
          <h3>Full Stack Developer.</h3>
          <p class="">
            Soy del Estado de San Luis Potosí, actualmente tengo 25 años con tres años de experiencia.
          </p>
          <div class="row">
            <div class="col-lg-12">
              <ul>
                <li><i class="icofont-rounded-right"></i> <strong>Correo: </strong> antoniohernandezjosesantiago@gmail.com</li>
                <li><i class="icofont-rounded-right"></i> <strong>Cumpleaños:</strong> 12 de Septiembre del año 1995</li>
                <li><i class="icofont-rounded-right"></i> <strong>Ubicación:</strong> San Nicolás de los Garza Nuevo León México</li>
              </ul>
            </div>
            <!--div class="col-lg-6">
              <ul>
                <li><i class="icofont-rounded-right"></i> <strong>Años:</strong> 25</li>
                <li><i class="icofont-rounded-right"></i> <strong>Ingeniería:</strong> TIC</li>
                <li><i class="icofont-rounded-right"></i> <strong>Correo:</strong> detalmx@outlook.com</li>
                <li><i class="icofont-rounded-right"></i> <strong>Freelance:</strong> Disponible</li>
              </ul>
            </div-->
          </div>
          <p>
            Tengo el conocimiento, la formación y las competencias específicas requeridas
            para integrarme en el desarrollo de proyectos de TI, me considero persona
            autodidacta, sagaz, proactivo, de soluciones oportunas.
          </p>
        </div>
      </div>

    </div>
  </section><!-- End About Section -->

</template>

<script>
export default {
name: "AboutComponent"
}
</script>

<style scoped>

</style>